'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomText = exports.TopText = exports.Content = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  letter-spacing: -1.5px;\n  line-height: 1.7rem;\n  text-transform: uppercase;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  letter-spacing: -1.5px;\n  line-height: 1.7rem;\n  text-transform: uppercase;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 35px;\n  font-weight: bold;\n'], ['\n  font-size: 35px;\n  font-weight: bold;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 30px;\n'], ['\n  font-size: 30px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Content = exports.Content = _styledComponents2.default.span(_templateObject);
var TopText = exports.TopText = _styledComponents2.default.span(_templateObject2);
var BottomText = exports.BottomText = _styledComponents2.default.span(_templateObject3);
//# sourceMappingURL=SmartImage.customText.styled.js.map